import React from 'react'

import Typography from 'components/Typography'

import AlternativesCarousel from './components/AlternativesCarousel'
import AlternativesList from './components/AlternativesList'

import classes from './Alternatives.module.scss'

const MAX_ALTERNATIVES = 3

const Alternatives = ({ alternatives, isCarousel = false, subtitle = '' }) => {
  const eventProps = {
    name: 'engagement_product_clickout',
    engagementComponent: 'product_overview',
    engagementDetails: 'card_product-alternative',
    engagementDestination: 'go-to_vendor-website',
  }
  const visibleAlternatives = alternatives?.slice(0, MAX_ALTERNATIVES) || []

  if (visibleAlternatives.length === 0) return ''

  return (
    <div>
      <div className={classes.titleContainer}>
        <Typography variant="title-9">Alternatives</Typography>
        {subtitle && <Typography variant="body-xs">{subtitle}</Typography>}
      </div>

      {isCarousel ? (
        <AlternativesCarousel alternatives={visibleAlternatives} eventProps={eventProps} />
      ) : (
        <AlternativesList alternatives={visibleAlternatives} eventProps={eventProps} />
      )}
    </div>
  )
}
export default Alternatives
